import { clone } from '../shared/services/lodashInJS.js';

import makeGenerator from './services/routesGenerator.js';
import App from './containers/App/App.jsx';
import OurVision, {About} from './containers/OurVision/OurVision.jsx';
import Homepage from './containers/Homepage/Homepage.jsx';
import LandingCompany from './containers/Landing/Company/LandingCompany.jsx';
import LandingCompanyConnected from './containers/Landing/Company/LandingCompanyConnected.jsx';
import LandingCompanyPurchase from './containers/Landing/Company/LandingCompanyPurchase.jsx';
import LandingCompanyFinance from './containers/Landing/Company/LandingCompanyFinance.jsx';
import LandingCompanyEngineering from './containers/Landing/Company/LandingCompanyEngineering.jsx';
import LandingEntrepriseHr from './containers/Landing/Company/LandingCompanyHr.jsx';
import LandingFreelance from './containers/Landing/Freelance/LandingFreelance.jsx';
import LandingFreelanceEngineering from './containers/Landing/Freelance/LandingFreelanceEngineering.jsx';
import LandingFreelancePurchase from './containers/Landing/Freelance/LandingFreelancePurchase.jsx';
import LandingFreelanceFinance from './containers/Landing/Freelance/LandingFreelanceFinance.jsx';
import LandingFreelanceHr from './containers/Landing/Freelance/LandingFreelanceHr.jsx';
import CGU from './containers/CGU/CGU.jsx';
import BringBusiness from './containers/BringBusiness/BringBusiness.jsx';
import BringBusinessCGU from './containers/CGU/BringBusinessCGU.jsx';
import DropNeed from './containers/DropNeed/DropNeed.jsx';
import Legal from './containers/Legal/Legal.jsx';
import Partnerships from './containers/Partnerships/Partnerships.jsx';
import Press from './containers/Press/Press.jsx';

import Blog from './containers/Blog/Blog.jsx';
import Article from './containers/Blog/Article/Article.jsx';

import CreateFreelanceContainer from './containers/Freelance/CreateFreelanceContainer.jsx';

import Documents from "./containers/Freelance/Containers/Documents/Documents.jsx";
import MySearch from './containers/Freelance/Containers/MySearch/MySearch.jsx';
import Missions from './containers/Freelance/Containers/Missions/Missions.jsx';
import Activities from './containers/Freelance/Containers/Activities/Activities.jsx';
import Interview from './containers/Freelance/Containers/Interview/Interview.jsx';
import Parcours from './containers/Freelance/Containers/Parcours/Parcours.jsx';
import Formations from './containers/Freelance/Containers/Formations/Formations.jsx';
import Languages from './containers/Freelance/Containers/Languages/Languages.jsx';
import AlertOffers from './containers/Freelance/Containers/Alert/AlertOffers.jsx';
import AdditionalInfo from './containers/Freelance/Containers/AdditionalInfo/AdditionalInfo.jsx';
import EditPurchaserContainer from './containers/Purchaser/EditPurchaserContainer.jsx';
import DoGeneralPresentation from './containers/Purchaser/Containers/GeneralPresentation/GeneralPresentation.jsx';
import EditFreelanceContainer from './containers/Freelance/EditFreelanceContainer.jsx';
import Availability from './containers/Freelance/Containers/Availability/Availability.jsx';
import NotificationsPage from './containers/NotificationsPage/NotificationsPage.jsx';
import OffersExamplesPurchase from './containers/OffersExamples/OffersExamplesPurchase.jsx';
import OffersExamplesFinance from './containers/OffersExamples/OffersExamplesFinance.jsx';
import OffersExamplesEngineering from './containers/OffersExamples/OffersExamplesEngineering.jsx';
import OffersExamplesHr from './containers/OffersExamples/OffersExamplesHr.jsx';
import ConfirmRegistration from './containers/ConfirmRegistration/ConfirmRegistration.jsx';

import Errors from './containers/Errors/Errors.jsx';
import NotFound from './containers/Errors/Components/NotFound.jsx';
import AccessDenied from './containers/Errors/Components/AccessDenied.jsx';

import ProfileFreelanceContainer from './containers/Freelance/ProfileFreelanceContainer.jsx';
import RedirectProfileFreelanceContainer from './containers/Freelance/RedirectProfileFreelanceContainer.jsx';
import MyProfileFreelanceContainer from './containers/Freelance/MyProfileFreelanceContainer.jsx';
import MyDashboardProfileContainer from './containers/Freelance/MyDashboardProfileContainer.jsx';
import MyAgentContainer from "./containers/Freelance/MyAgentContainer.jsx";
import LoadedFreelance from './components/Freelance/Component/LoadedFreelance/LoadedFreelance.jsx';
import History from './containers/Freelance/Containers/History/History.jsx';
import Monitor from './containers/Freelance/Containers/Monitor/Monitor.jsx';
import PositioningsAndProgessiMissions from "./components/PositioningsAndProgessiMissions/PositioningsAndProgessiMissions.jsx";
import Review from './containers/Freelance/Containers/Review/Review.jsx';

import FreelanceSearchContainer from './containers/Freelance/Containers/Search/FreelanceSearchContainer.jsx';
import FreelanceSearchResultsContainer from './containers/Freelance/Containers/Search/FreelanceSearchResultsContainer.jsx';
import FreelanceSearchViewContainer from './containers/Freelance/Containers/Search/FreelanceSearchViewContainer.jsx';

import PurchaserContainer from './containers/Purchaser/PurchaserContainer.jsx';
import PurchaserSearchContainer from './containers/Purchaser/Containers/Search/PurchaserSearchContainer.jsx';
import PurchaserSearchResultsContainer from './containers/Purchaser/Containers/Search/PurchaserSearchResultsContainer.jsx';
import PurchaserSearchViewContainer from './containers/Purchaser/Containers/Search/PurchaserSearchViewContainer.jsx';
import PurchaserDetails from './containers/Purchaser/Components/PurchaserDetails/PurchaserDetails.jsx';

import OfferSearchContainer from './containers/Offer/Containers/OfferSearchContainer.jsx';
import OfferDetailsContainer from './containers/Offer/Containers/OfferDetailsContainer.jsx';
import OfferSearchViewContainer from './containers/Offer/Containers/OfferSearchViewContainer.jsx';
import OfferContainer from './containers/Offer/OfferContainer.jsx';
import OfferDetailsEdit from './containers/Offer/Components/OfferDetails/OfferDetailsEdit.jsx';
import OfferCreate from './containers/Offer/Components/OfferCreate/OfferCreate.jsx';
import OfferDetails from './containers/Offer/Components/OfferDetails/OfferDetails.jsx';
import OfferSearchResults from './containers/Offer/Components/OfferSearchResults/OfferSearchResults.jsx';

import Login from './containers/Login/Login.jsx';
import RegisterAsFreelance from './containers/Register/RegisterAsFreelance.jsx';
import RegisterAsDo from './containers/Register/RegisterAsDo.jsx';

import MyMissionsFreelanceContainer from "./containers/Freelance/MyMissionsFreelanceContainer.jsx";
import ProfilePresentation from "./containers/Freelance/Containers/ProfilePresentation/ProfilePresentation.jsx";
import MyAccountContainer from "./containers/Freelance/MyAccountContainer.jsx";
import MyAccount from "./containers/Freelance/Containers/MyAccount/MyAccount.jsx";
import Skills from "./containers/Freelance/Containers/Skills/Skills.jsx";
import FreelanceListContainers from "./containers/Freelance/FreelanceListContainers.jsx";

// import UploadCv from './containers/Freelance/Containers/UploadCv/UploadCv.jsx';
// import GeneralPresentation from './containers/Freelance/Containers/GeneralPresentation/GeneralPresentation.jsx';

const baseAdminRoutes = [
  {
    name: 'show',
    path: '',
    component: LoadedFreelance,
    exact: true,
  },
  // ℹ️ same as uploaded DC pdf
  // {
  //   name: 'show',
  //   path: '/show',
  //   component: LoadedFreelance,
  //   exact: true,
  // },
  {
    name: 'review',
    path: '/review',
    component: Review,
    exact: true,
  },
  {
    name: 'history',
    path: '/history',
    component: History,
    exact: true
  },
  {
    name: 'positionings-and-progessi-missions',
    path: '/positionnements-et-missions',
    component: PositioningsAndProgessiMissions,
    exact: true
  },
  {
    name: 'monitor',
    path: '/monitor',
    component: Monitor,
    exact: true
  },
  {
    name: 'cv',
    path: '/cv',
    component: Documents,
    exact: true
  },
  {
    name: 'pres',
    path: '/pres',
    component: ProfilePresentation,
    exact: true
  },
  {
    name: 'preferences',
    path: '/preferences',
    component: AdditionalInfo,
    exact: true
  },
  {
    name: 'mission',
    path: '/mission',
    component: Missions,
    exact: true
  },
  {
    name: 'interview',
    path: '/interview',
    component: Interview,
    exact: true
  },
  {
    name: 'parcours',
    path: '/parcours',
    component: Parcours,
    exact: true
  },
  {
    name: 'formations',
    path: '/formations',
    component: Formations,
    exact: true
  },
  {
    name: 'activities',
    path: '/secteurs',
    component: Activities,
    exact: true
  },
  {
    name: 'my-search',
    path: '/ma-recherche',
    component: MySearch,
    exact: true
  },
  {
    name: 'extras',
    path: '/extras',
    component: Languages,
    exact: true
  },
  {
    name: 'alertes',
    path: '/alertes',
    component: AlertOffers,
    exact: true
  },
  {
    name: 'avail',
    path: '/availability',
    component: Availability,
    exact: true
  },
  /*{
    name: 'dashboard',
    path: '/dashboard',
    exact: true,
    component: Availability
  },*/
  {
    name: 'skills',
    path: '/competences',
    exact: true,
    component: Skills
  },
];

function generateAdminRoute(basePath) {
  const AdminRoutes = [];
  baseAdminRoutes.forEach((route) => {
    const _route = clone(route);
    _route.path = basePath + route.path;
    AdminRoutes.push(_route);
  });
  return AdminRoutes;
}

export const freelanceSearchRoutes = [
  {
    name: 'view',
    path: '/recherche/view/:offset([0-9]+)',
    component: FreelanceSearchViewContainer,
    routes: generateAdminRoute('/recherche/view/:offset([0-9]+)')
  },
  {
    name: 'results',
    path: '/recherche',
    component: FreelanceSearchResultsContainer
  }
];

export const offerCreateRoutes = [
  {
    name: 'create',
    path: '/annonces/create',
    component: OfferCreate,
    exact: true,
  }
];

export const offerSearchRoutes = [
  {
    name: 'search',
    path: '/annonces',
    exact: true,
    component: OfferSearchContainer,
    routes: [
      {
        name: 'results',
        path: '/annonces',
        component: OfferSearchResults,
        exact: true,
      }
    ]
  },
  {
    name: 'search',
    path: '/annonces/views',
    component: OfferSearchContainer,
    routes: [
      {
        name: 'viewer',
        path: '/annonces/views/:offset([0-9]+)',
        component: OfferSearchViewContainer,
        routes: [
          {
            name: 'edit',
            path: '/annonces/views/:offset([0-9]+)/edit',
            component: OfferDetailsEdit,
            exact: true,
          },
          {
            name: 'views',
            path: '/annonces/views/:offset([0-9]+)',
            component: OfferDetails,
            exact: true,
          },
        ]
      }
    ]
  }
];

export const clientsSearchRoutes = [
  {
    name: 'search',
    path: '/do',
    component: PurchaserSearchContainer,
    routes: [
      {
        name: 'viewer',
        path: '/do/views/:offset([0-9]+)',
        component: PurchaserSearchViewContainer,
        routes: [
          {
            name: 'views',
            path: '/do/views/:offset([0-9]+)',
            component: PurchaserDetails,
          },
        ]
      },
      {
        name: 'results',
        path: '/do',
        component: PurchaserSearchResultsContainer,
      }
    ]
  }
];

const routes = [
  {
    component: App,
    routes: [
      {
        name: 'about',
        path: '/a-propos',
        exact: true,
        component: About
      },
      {
        name: 'blog',
        path: '/blog',
        exact: true,
        component: Blog
      },
      {
        name: 'blog-category',
        path: '/blog/categorie/:slug([A-z0-9-]+)',
        exact: true,
        component: Blog
      },
      {
        name: 'blog-tag',
        path: '/blog/tag/:slug([A-z0-9-]+)',
        exact: true,
        component: Blog
      },
      {
        name: 'blog-article',
        path: '/blog/:slug([A-z0-9-]+)',
        exact: true,
        component: Article
      },
      {
        name: 'bring-business',
        path: '/apport-d-affaires',
        exact: true,
        component: BringBusiness
      },
      {
        name: 'bring-business-cgu',
        path: '/cgu-apport-d-affaires',
        exact: true,
        component: BringBusinessCGU
      },
      {
        name: 'cgu',
        path: '/conditions-generales-d-utilisation',
        exact: true,
        component: CGU
      },
      {
        name: 'confirm-registration',
        path: '/confirm-registration',
        exact: true,
        component: ConfirmRegistration
      },
      {
        name: 'drop-need',
        path: '/proposer-une-mission',
        exact: true,
        component: DropNeed
      },
      {
        name: 'homepage',
        path: '/',
        exact: true,
        component: Homepage
      },
      {
        name: 'landing-company',
        path: '/entreprise',
        exact: true,
        component: LandingCompany
      },
      {
        name: 'landing-company-connected',
        path: '/entreprise/connecte',
        exact: true,
        component: LandingCompanyConnected
      },
      {
        name: 'landing-company-purchase',
        path: '/entreprise/achats',
        exact: true,
        component: LandingCompanyPurchase
      },
      {
        name: 'landing-company-finance',
        path: '/entreprise/finance',
        exact: true,
        component: LandingCompanyFinance
      },
      {
        name: 'landing-company-hr',
        path: '/entreprise/rh',
        exact: true,
        component: LandingEntrepriseHr
      },
      {
        name: 'landing-company-engineering',
        path: '/entreprise/ingenierie',
        exact: true,
        component: LandingCompanyEngineering
      },
      {
        name: 'landing-freelance',
        path: '/freelance',
        exact: true,
        component: LandingFreelance
      },
      {
        name: 'landing-freelance-purchase',
        path: '/freelance/achats',
        exact: true,
        component: LandingFreelancePurchase
      },
      {
        name: 'landing-freelance-finance',
        path: '/freelance/finance',
        exact: true,
        component: LandingFreelanceFinance
      },
      {
        name: 'landing-freelance-hr',
        path: '/freelance/rh',
        exact: true,
        component: LandingFreelanceHr
      },
      {
        name: 'landing-freelance-engineering',
        path: '/freelance/ingenierie',
        exact: true,
        component: LandingFreelanceEngineering
      },
      {
        name: 'login',
        path: '/login',
        exact: true,
        component: Login
      },
      {
        name: 'our-vision',
        path: '/notre-vision',
        exact: true,
        component: OurVision
      },
      {
        name: 'register-freelance',
        path: '/inscription-freelance',
        exact: true,
        component: RegisterAsFreelance
      },
      {
        name: 'register-do',
        path: '/inscription-do',
        exact: true,
        component: RegisterAsDo
      },
      {
        name: 'legal',
        path: '/cadre-reglementaire',
        exact: true,
        component: Legal
      },
      {
        name: 'partnerships',
        path: '/nos-partenaires',
        exact: true,
        component: Partnerships
      },
      {
        name: 'press',
        path: '/presse',
        exact: true,
        component: Press
      },
      {
        name: 'offers-examples-purchase',
        path: '/exemples-de-missions-achats',
        exact: true,
        component: OffersExamplesPurchase
      },
      {
        name: 'offers-examples-finance',
        path: '/exemples-de-missions-finance',
        exact: true,
        component: OffersExamplesFinance
      },
      {
        name: 'offers-examples-hr',
        path: '/exemples-de-missions-rh',
        exact: true,
        component: OffersExamplesHr
      },
      {
        name: 'offers-examples-engineering',
        path: '/exemples-de-missions-ingenierie',
        exact: true,
        component: OffersExamplesEngineering
      },
      {
        name: 'notifications',
        path: '/notifications',
        exact: true,
        component: NotificationsPage,
      },
      {
        name: 'search',
        path: '/recherche',
        component: FreelanceSearchContainer,
        routes: freelanceSearchRoutes
      },
      {
        name: 'profiles',
        path: '/profils',
        exact: true,
        component: FreelanceListContainers,
      },

      {
        name: 'edit-freelance',
        path: '/edit/freelance/:segment',
        component: EditFreelanceContainer,
        routes: [
          {
            name: 'cv',
            path: '/edit/freelance/cv',
            component: Documents,
            exact: true
          },
          {
            name: 'pres',
            path: '/edit/freelance/pres',
            component: ProfilePresentation,
            exact: true
          },
          /*{
            name: 'account',
            path: '/edit/freelance/account',
            component: MyAccount,
            exact: true
          },*/
          {
            name: 'my-search',
            path: '/edit/freelance/ma-recherche',
            component: MySearch,
            exact: true
          },
          {
            name: 'preferences',
            path: '/edit/freelance/preferences',
            component: AdditionalInfo,
            exact: true
          },
          {
            name: 'mission',
            path: '/edit/freelance/mission',
            component: Missions,
            exact: true
          },
          {
            name: 'activities',
            path: '/edit/freelance/secteurs',
            component: Activities,
            exact: true
          },
          {
            name: 'parcours',
            path: '/edit/freelance/parcours',
            component: Parcours,
            exact: true
          },
          {
            name: 'formations',
            path: '/edit/freelance/formations',
            component: Formations,
            exact: true
          },
          {
            name: 'extras',
            path: '/edit/freelance/extras',
            component: Languages,
            exact: true
          },
          {
            name: 'alertes',
            path: '/edit/freelance/alertes',
            component: AlertOffers,
            exact: true
          },
          {
            name: 'avail',
            path: '/edit/freelance/availability',
            component: Availability,
            exact: true
          }
        ]
      },
      {
        name: 'create-freelance',
        path: '/create/freelance',
        exact: true,
        component: CreateFreelanceContainer,
      },
      {
        name: 'freelance-agent',
        path: '/freelance/mon-agent',
        component: MyAgentContainer,
        exact: true
      },
      {
        name: 'old-freelance-profile',
        path: '/freelance/:slug-:user_id([0-9]+)-:freelance_id([0-9]+)',
        component: RedirectProfileFreelanceContainer
      },
      {
        name: 'freelance-profile',
        path: '/freelance/:slug([A-z0-9-]+)',
        component: ProfileFreelanceContainer,
        routes: generateAdminRoute('/freelance/:slug')
      },
      {
        name: 'my-freelance-profile',
        path: '/profil',
        exact: true,
        component: MyProfileFreelanceContainer
      },
      {
        name: 'my-positions-and-missions',
        path: '/mes-positionnements-et-missions',
        exact: true,
        component: MyMissionsFreelanceContainer
      },
      {
        name: 'freelance-dashboard',
        path: '/dashboard',
        exact: true,
        component: MyDashboardProfileContainer
      },
      {
        name: 'my-account',
        path: '/mon-compte',
        exact: true,
        component: MyAccountContainer
      },
      {
        name: 'edit-do',
        path: '/edit/do/:element',
        component: EditPurchaserContainer,
        routes: [
          {
            name: 'pres',
            path: '/edit/do/presentation',
            component: DoGeneralPresentation,
            exact: true
          },
          {
            name: 'account',
            path: '/edit/do/account',
            component: MyAccount,
            exact: true
          },
        ]
      },
      {
        name: 'purchasers',
        path: '/do',
        component: PurchaserContainer,
        routes: clientsSearchRoutes
      },
      {
        name: 'offers',
        path: '/annonces',
        component: OfferContainer,
        routes: offerCreateRoutes.concat(offerSearchRoutes, [
          {
            name: 'details',
            path: '/annonces/:offer([A-z0-9-]+)',
            component: OfferDetailsContainer,
            routes: [
              {
                name: 'show',
                path: '/annonces/:offer([A-z0-9-]+)',
                component: OfferDetails,
                exact: true,
              },
              {
                name: 'edit',
                path: '/annonces/:offer([A-z0-9-]+)/edit',
                component: OfferDetailsEdit,
                exact: true,
              }
            ]
          }
        ])
      },
      {
        name: 'errors',
        path: '/errors/:code([0-9]+)',
        component: Errors,
        routes: [
          {
            name: 'not-found',
            path: '/errors/404',
            redirect: true,
            exact: true,
            component: NotFound
          },
          {
            name: 'access-denied',
            path: '/errors/401',
            redirect: true,
            exact: true,
            component: AccessDenied
          },
        ]
      },
      {
        redirect: false,
        code: 404,
        component: Errors,
        routes: [
          {
            name: 'not-found',
            redirect: true,
            exact: true,
            component: NotFound
          }
        ]
      }
    ]
  }
];

export default routes;
export const generate = makeGenerator(routes);
